export const MODEL_NAME = "modelName";
export const DESCRIPTION = "description";
export const COMMUNITY_ID = "communityId";
